<template>
  <footer class="bg-bkk-100" :class="{ 'position-bottom': positionFixed }">
    <hr />
    <div
      class="mx-auto max-w-7xl px-6 py-6 md:flex md:items-center md:justify-between lg:px-8"
    >
      <div
        v-for="(element, index) in sites"
        :key="index"
        class="mt-8 md:order-1 md:mt-0"
      >
        <router-link
          :to="{ name: 'sbkSite', params: { name: element.name } }"
          target="_blank"
          class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
        >
          <p class="text-xl font-bold pb-1" :class="{ 'text-white ': bgFixed }">
            {{ getTranslatedPageTitle(element) }}
          </p>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { fetchSites } from "~/api/sbk";
import { useClientStore } from "../../../store/v2/client";

export default {
  name: "FooterLinks",
  props: {
    positionFixed: Boolean,
    bgFixed: Boolean,
  },
  setup() {
    const clientStore = useClientStore();

    return {
      clientStore,
    };
  },
  data() {
    return {
      sites: [],
      atmCampaignId: null,
    };
  },
  async mounted() {
    this.atmCampaignId = this.clientStore.atmCampaign;
    fetchSites()
      .then((sites) => {
        this.sites = sites.data;
      })
      .catch(() => {
        // redirect to maintenance page if request fails
        return this.$router.push({
          name: "maintenancePage",
        });
      });
  },
  methods: {
    getTranslatedPageTitle(page) {
      switch (page.name) {
        case "impressum-mein-phileo":
          return this.$t("ssosbk.footer.imprint");
        case "teilnahmebedingungen-mein-phileo":
          return this.$t("ssosbk.footer.termsofuse");
        case "datenschutz-mein-phileo":
          return this.$t("ssosbk.footer.privacy");
        case "barrierefreiheit-mein-phileo":
          return this.$t("ssosbk.footer.accessibility");
        case "leichte-sprache-mein-phileo":
          return this.$t("ssosbk.footer.simplelanguage");
        default:
          return "";
      }
    },
  },
};
</script>
<style>
.position-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
